<template>
  <div>
    <v-dialog v-model="showDialog" persistent :dark="protocol.dark" max-width="600px">
      <v-card>
        <v-toolbar color="accent" :dark="protocol.dark">
          <v-toolbar-side-icon>
            <v-icon>mdi-account</v-icon>
          </v-toolbar-side-icon>
          <v-toolbar-title v-if="!currentUser.editing">Legg til deltaker</v-toolbar-title>
          <v-toolbar-title v-else>Rediger deltaker</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="primary" dark grow>
          <v-tab key="person">Person</v-tab>
          <v-tab key="company">Bedrift</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="person">
            <v-card-text class="p-2 p-sm-4 mb-5 pb-5">
              <v-container grid-list-md p-0>
                <v-form ref="personForm" v-model="valid" lazy-validation class="mb-5">
                  <v-layout wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="currentUser.firstname"
                        label="Fornavn*"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="currentUser.lastname"
                        label="Etternavn*"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                    >Fødselsdato: Velg dato med datovelgeren. Format dd.mm.åååå</v-flex>
                    <v-flex xs12>
                      <birth-datepicker
                        v-model="currentUser.bdate"
                        :locale="monthNames"
                        :high="windowWidth <= 600"
                        :valueIsString="true"
                        style="width:100%;height:100%;"
                        color="primary"
                      />
                    </v-flex>
                    <v-flex xs12 style="display:none;">
                      <v-text-field
                        v-model="currentUser.bdate"
                        label="Fødselsdato* (Velg dato med datovelgeren over)"
                        hint
                        required
                        :disabled=true
                        :rules="dateRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="currentUser.email"
                        type="email"
                        label="Epost"
                        :rules="emailRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="currentUser.phone"
                        type="number"
                        label="Telefon*"
                        :rules="phoneRules"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
              <small>* felter er obligatoriske</small>
            </v-card-text>
          </v-tab-item>
          <v-tab-item key="company">
            <v-card-text class="p-2 p-sm-4">
              <v-container grid-list-md p-0>
                <v-form ref="companyForm" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="currentUser.companyName"
                        label="Navn på firma*"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="currentUser.email"
                        type="email"
                        label="Epost"
                        :rules="emailRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="currentUser.phone"
                        type="number"
                        label="Telefon*"
                        :rules="phoneRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="currentUser.orgnum"
                        type="number"
                        label="Organisasjonsnr*"
                        :rules="orgRules"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
              <small>* felter er obligatoriske</small>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="close">Lukk</v-btn>
          <v-btn color="primary" @click="saveCurrentUser" v-if="!currentUser.editing">Legg til</v-btn>
          <v-btn color="primary" @click="saveCurrentUser" v-else>Oppdater</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import birthDatepicker from "vue-birth-datepicker/src/birth-datepicker";
import Participant from "../../models/participant"
export default {
  props: {
    user: {
      type: Object,
      required: false
    }
  },
  components: { birthDatepicker },
  data() {
    return {
      currentUser: new Participant(),
      showDialog: true,
      windowWidth: window.innerWidth,
      monthNames: [
        "jan",
        "feb",
        "mar",
        "apr",
        "mai",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "des"
      ],
      tab: null,
      valid: true,
      bdate: null,
      nameRules: [
        v => !!v || "Navn er obligatorisk",
        v => (v && v.length <= 100) || "Navn kan ikke være lenger enn 100 tegn"
      ],
      emailRules: [
        v => {
          if (v) return /.+@.+/.test(v) || "Epost er ikke gyldig";
          else return true;
        }
      ],
      phoneRules: [
        v => !!v || "Telefon er obligatorisk",
        v => (v && v.length <= 12) || "Telefon kan ikke være lenger enn 12 siffer"
      ],
      orgRules: [v => !!v || "Org nr. er obligatorisk"],
      dateRules: [v => !!v || "Fødselsdato er obligatorisk"]
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
    })
    if(this.user != null && this.user != undefined) {
      this.currentUser = JSON.parse(JSON.stringify(this.user))
      if(this.currentUser.isCompany) {
        this.tab = 1
      }
    }
  },
  methods: {
    saveCurrentUser: function() {
      let saved = false;
      if (this.tab == 1) {
        if (this.$refs.companyForm.validate()) {
          this.currentUser.isCompany = true
          saved = true;
        }
        else {
          this.$store.commit("setErrorMessage", 'Beklager, men skjemaet er ikke riktig utfylt. Se feilmelding under feltene som ikke er korrekt')
        }
      } else {
        if (this.$refs.personForm.validate()) {
          this.currentUser.isCompany = false
          saved = true;
        }
        else {
          this.$store.commit("setErrorMessage", 'Beklager, men skjemaet er ikke riktig utfylt. Se feilmelding under feltene som ikke er korrekt')
        }
      }
      if (saved) {
        this.$emit("person-saved", JSON.parse(JSON.stringify(this.currentUser)));
        this.$refs.companyForm.reset();
        this.$refs.companyForm.resetValidation();
        this.$refs.personForm.reset();
        this.$refs.personForm.resetValidation();
      }
    },
    formatDate() {
      const [year, month, day] = this.bdate.split("-");
      this.currentUser.bdate = `${day}.${month}.${year}`;
    },
    close: function() {
      this.$emit("close-dialog");
    }
  },
  computed: {
    protocol: {
      get() {
        return this.$store.state.protocol;
      }
    }
  },
  watch: {
    user: function(newVal, oldVal) {
      // watch it
      this.currentUser = JSON.parse(JSON.stringify(newVal))
    }
  }
};
</script>

<style>
.theme--light.v-messages.error--text, .theme--light.v-messages, .error--text {
  color: red !important;
}
</style>